import { useCallback, useEffect } from 'react';
import { DrugItem } from 'src/api/types';
import getTopDrugs from 'src/api/requests/getTopDrugs';
import useTopDrugsStore from './useTopDrugsStore';
import useUserLocation from './useUserLocation';

const useTopDrugsHooks = () => {
  const topDrugsList = useTopDrugsStore((state) => state.topDrugsList);
  const isLoading = useTopDrugsStore((state) => state.isLoading);
  const setTopDrugsList = useTopDrugsStore((state) => state.setTopDrugsList);
  const setIsLoading = useTopDrugsStore((state) => state.setIsLoading);

  const userLocation = useUserLocation();

  const retrieveTopDrugs = useCallback(async (): Promise<DrugItem[]> => {
    setIsLoading(true);
    try {
      const response = await getTopDrugs();
      setTopDrugsList(response);
      return response;
    } catch (err) {
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [setTopDrugsList]);

  useEffect(() => {
    // Reload top drugs on location change
    // Check for data state is required to prevent duplicated API calls from the client side
    if (!isLoading && !topDrugsList?.length && userLocation?.name) {
      retrieveTopDrugs();
    }
  }, [userLocation?.name, topDrugsList, isLoading, retrieveTopDrugs]);
};

export default useTopDrugsHooks;
